import type { Route } from "@vaadin/router";

import { pages } from "../pages/index";
import "../web-kiosk";

export type { Route } from "@vaadin/router";

export const routeTree: Route[] = [
  {
    path: "",
    redirect: `/default/en/new-session${window.location.search}`,
  },
  {
    path: "/:payor/:locale",
    component: "web-kiosk",

    children: pages.map(({ path, component, key }) => ({
      path,
      component,

      action(ctx) {
        ctx.params.contentKey = key;
      },
    })),
  },
];
